import React from "react";
import Man1 from "../assets/img/man1.webp";
import Man2 from "../assets/img/man2.jpg";
import Man3 from "../assets/img/man3.jpg";
import Woman1 from "../assets/img/woman2.jpg";
import Man4 from "../assets/img/man4.jpg";
import Woman3 from "../assets/img/woman6.jpg";

/**
 * ThirdHome.js
 * "Our Team" page component — green theme (#16a34a)
 *
 * Usage: import ThirdHome from './components/ThirdHome';
 */

const GREEN = "#16a34a";
const CARD_BG = "#1A2028";
const MUTED = "#6b7280";

const team = [
    {
        id: 1,
        name: "Ethan Huxley",
        role: "Product Manager",
        bio: "Leads product strategy and coordinates between design and engineering.",
        initials: "AM",
        image: Man1
    },
    {
        id: 2,
        name: "Jacob Williams",
        role: "Crypto Trading Specialist",
        bio: "Leads product strategy and coordinates between design and engineering.",
        initials: "LP",
        image: Man2
    },
    {
        id: 3,
        name: "Sofia Chen",
        role: "Blockchain Security Engineer",
        bio: "Leads product strategy and coordinates between design and engineering.",
        initials: "SC",
        image: Woman1
    },
    {
        id: 4,
        name: "Noah Smith",
        role: "Client Support Agent",
        bio: "Leads product strategy and coordinates between design and engineering.",
        initials: "NS",
        image: Man3
    },
    {
        id: 5,
        name: "Ammy Gray",
        role: "Crypto Trading Specialist",
        bio: "Leads product strategy and coordinates between design and engineering.",
        initials: "NS",
        image: Woman3
    },
    {
        id: 6,
        name: "Kevin Miller",
        role: "Crypto Trading Specialist",
        bio: "Leads product strategy and coordinates between design and engineering.",
        initials: "NS",
        image: Man4
    },
];

export default function ThirdHome() {
    return (
        <div style={{ fontFamily: "Inter, Roboto, system-ui, -apple-system", color: "#111827", padding: 24 }}>
            <header style={{ maxWidth: 980, margin: "0 auto 28px", textAlign: "center" }}>
                <h1 style={{ margin: 0, color: GREEN, fontSize: 36, lineHeight: 1.05 }}>Our Team</h1>
                <p style={{ marginTop: 10, color: MUTED, fontSize: 15 }}>
                    Small team, big impact. Meet the people building product and supporting customers.
                </p>
            </header>

            <main style={{ maxWidth: 1100, margin: "0 auto" }}>
                <section
                    style={{
                        display: "grid",
                        // increased min width by ~20%: 240 -> 288
                        gridTemplateColumns: "repeat(auto-fit, minmax(288px, 1fr))",
                        gap: 22,
                    }}
                >
                    {team.map((member) => (
                        <article
                            key={member.id}
                            style={{
                                background: CARD_BG,
                                borderRadius: 12,
                                // increased padding by ~20%: 16 -> 20
                                padding: 20,
                                boxShadow: "0 1px 3px rgba(15, 23, 42, 0.06)",
                                display: "flex",
                                gap: 14,
                                alignItems: "flex-start",
                            }}
                        >
                            <div
                                aria-hidden
                                style={{
                                    // increased image size by ~20%: 84 -> 100
                                    minWidth: 100,
                                    minHeight: 100,
                                    borderRadius: 12,
                                    background: `url(${member.image}) center/cover no-repeat`,
                                    color: "#fff",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontWeight: 700,
                                    // increased font size inside image
                                    fontSize: 22,
                                    // increased flex basis by ~20%: 64 -> 80
                                    flex: "0 0 80px",
                                }}
                            >
                                
                            </div>

                            <div style={{ flex: 1 }}>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 10 }}>
                                    <div>
                                        <h3 style={{ margin: 0, fontSize: 19, color: "#bbbbbbff" }}>{member.name}</h3>
                                        <div style={{ marginTop: 6, color: MUTED, fontSize: 15 }}>{member.role}</div>
                                    </div>

                                    <button
                                        aria-label={`Contact ${member.name}`}
                                        style={{
                                            background: "transparent",
                                            border: `1px solid ${GREEN}`,
                                            color: GREEN,
                                            // increased button padding and font size
                                            padding: "8px 12px",
                                            borderRadius: 10,
                                            cursor: "pointer",
                                            fontSize: 15,
                                        }}
                                        
                                    >
                                        Message
                                    </button>
                                </div>

                                <p style={{ marginTop: 10, marginBottom: 8, color: "#4d5b70ff", fontSize: 15 }}>{member.bio}</p>

                                <div style={{ display: "flex", gap: 10, marginTop: 6 }}>
                                    <SocialIcon label="twitter" color={GREEN} />
                                    <SocialIcon label="linkedin" color={GREEN} />
                                    <SocialIcon label="github" color={GREEN} />
                                </div>
                            </div>
                        </article>
                    ))}
                </section>

                <div style={{ textAlign: "center", marginTop: 28 }}>
                    <button
                        
                        style={{
                            background: GREEN,
                            color: "#fff",
                            border: "none",
                            // increased CTA size
                            padding: "12px 18px",
                            borderRadius: 12,
                            fontSize: 17,
                            cursor: "pointer",
                        }}
                    >
                        See full team
                    </button>
                </div>
            </main>
        </div>
    );
}

function SocialIcon({ label, color }) {
    // simple generic icon circle with first letter
    const letter = label?.[0]?.toUpperCase() ?? "?";
    return (
        <div
            title={label}
            style={{
                width: 34,
                height: 34,
                borderRadius: 8,
                background: `${color}22`, // faint tint
                color: color,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 700,
                fontSize: 13,
            }}
        >
            {letter}
        </div>
    );
}